import type { ReactElement, ReactNode } from 'react';
import { ThemeToggle } from '../components/ui/ThemeToggle';
import { BiniLogoHero } from '../components/BiniLogo';

interface Props {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

// Layout para /login y /signup. Hero con logo PNG completo (bull facetado,
// bear facetado, TB metálico, candles, arrow, TRADING, ANALYZE EXECUTE GROW,
// firma "Binimeliz" cursiva dorada) arriba, formulario debajo.
export function AuthLayout({ title, subtitle, children }: Props): ReactElement {
  return (
    <div className="min-h-screen relative bg-surface-base text-ink overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-[600px] pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at center top, rgb(16 185 129 / 0.16), transparent 60%)',
        }}
      />
      <div
        aria-hidden
        className="absolute inset-0 bg-grain bg-grain pointer-events-none opacity-30"
      />

      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>

      <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12">
        <div className="w-full max-w-md space-y-7">
          {/* Hero con el logo completo (incluye Binimeliz cursiva) */}
          <BiniLogoHero maxWidth={440} />

          <div className="rounded-2xl border border-surface-border bg-surface-elevated/85 backdrop-blur-sm p-8 shadow-xl shadow-black/5 dark:shadow-black/40">
            <h1 className="font-display text-3xl tracking-tight text-ink mb-1">{title}</h1>
            {subtitle && <p className="text-sm text-ink-muted mb-6">{subtitle}</p>}
            {children}
          </div>

          <p className="text-center text-[11px] text-ink-faint tracking-[0.2em] uppercase">
            v0.1 · beta privada
          </p>
        </div>
      </div>
    </div>
  );
}
